<template lang="pug">
  el-card
    span.title Listagem de mensagens
    el-table(
      :data="mensagens"
      style="width: 100%; padding-top: 30px"
      @row-click='lerMensagem'
      v-loading="loading"
    ).clickable-rows
      template(slot="empty") Nenhuma mensagem disponível.
      el-table-column(width="50" prop="status" )
        template(slot-scope="{row}")
          i.icon-envelope(:class="renderIcone(row)")
      el-table-column(label="Data e hora")
        template(slot-scope="{row}") {{ row.dataUltimaMensagem | timestamp }}
      el-table-column(label="Assunto")
          template(slot-scope="{row}") {{ row.assunto }}
      el-table-column(prop="numero" label="Nº do edital")
          template(slot-scope="{row}") {{ row.solicitacaoCredenciado.edital.numero }}
      el-table-column(prop="prazo" label="Prazo de resposta")
          template(slot-scope="{row}")
            span(:class="classPrazo(row.mensagens)") {{ buscarPrazo(row.mensagens) }}
    Pagination(:total='quantidadeResultados' :pagina='paginaAtual' :tamanhoPagina='tamanhoPagina' @changePage='changePage')
</template>

<script>
import { Pagination, AppNotificacao } from 'sicarf-components';
import { listConversas } from '@/services/conversaService';
import { getUsuario } from '@/store/auth';
import moment from 'moment';

export default {
  components: {
    Pagination,
  },
  mixins: [
    AppNotificacao
  ],
  data() {
    return {
      mensagens: [],
      quantidadeResultados: 0,
      paginaAtual: 0,
      tamanhoPagina: 15,
      usuario: [],
      prazo: [],
      lido: false,
      loading: true,
    };
  },
  mounted() {
    this.handleSearch();
    this.usuario = getUsuario();
  },
  methods: {
    async handleSearch() {
      try {
        this.loading = true;
        const response = await listConversas(this.paginaAtual, this.tamanhoPagina);
        this.mensagens = response.content.reverse();
        this.quantidadeResultados = response.totalElements;
        this.loading = false;
      } catch (e) {
        this.loading = false;
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Ocorreu um erro ao buscar conversas.')
      }
    },
    changePage (newPage) {
      this.paginaAtual = newPage - 1;
      this.handleSearch(this.paginaAtual);
    },
    lerMensagem(row) {
      this.$router.push({ path: `/credenciado/mensagens/responder/${row.id}` });
    },
    dateFromTimestamp(timestamp) {
      const date = new Date(timestamp);

      const day = '0' + date.getUTCDate();
      const month = '0' + (date.getUTCMonth() + 1);
      const year = date.getUTCFullYear();

      return `${day.substr(-2)}/${month.substr(-2)}/${year}`;
    },
    renderIcone(row) {
      var count = 0;
      row.mensagens.forEach(item => {
        if (item.remetente) {
          if (item.status !== 'LIDA' && item.remetente.cpfCnpj !== this.usuario.pessoa.cpfCnpj) {
            count += 1;
          }
        }
      })
      if (count > 0) {
        return 'far fa-envelope'
      } else {
        return 'far fa-envelope-open'
      }
    },
    classPrazo(mensagens) {
      const prazo = mensagens.filter((item) => {
        if (item.dataLimiteResposta !== null) {
          return item;
        }
      });

      if (prazo.length > 0) {
        const prazoLimite = this.dateFromTimestamp(prazo[0].dataLimiteResposta);

        if (moment(this.formataData(prazoLimite)).isBefore(moment(new Date()))) {
          return 'prazo-vencido';
        }
      }
    },
    buscarPrazo(mensagens) {
      const prazo = mensagens.filter((item) => {
        if (item.dataLimiteResposta !== null) {
          return item;
        }
      });

      if (prazo.length > 0) {
        const prazoLimite = this.dateFromTimestamp(prazo[0].dataLimiteResposta);
        return prazoLimite;
      } else {
        return '-';
      }
    },
    formataData(data) {
      let dataFormatada = null;
      if (data !== null) {
        const ano = data.substr(6, 4);
        const mes = data.substr(2, 4);
        const dia = data.substr(0, 2);
        dataFormatada = ano + mes + dia;
      } else {
        dataFormatada = null;
      }

      return new Date(dataFormatada);
    }
  }
};
</script>

<style scoped>
.title {
  color: 606266;
  font-size: 20px;
  font-weight: bold;
}
.icon-envelope {
  font-size: 20px;
}

.el-card {
  border-radius: 20px;
  padding: 12px;
}

.middle {
  margin-top: 30px;
}

.prazo-vencido {
  color: #F56C6C;
}

.clickable-rows {
  cursor: pointer;
}
</style>
